import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import ('./assets/scss/main.scss')
import DatetimePicker from 'vuetify-datetime-picker'
import maska from 'maska'
import ('@/assets/js/peerjs.min')

Vue.config.productionTip = false

Vue.use(maska)
Vue.use(DatetimePicker)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
